import { ThemeProvider } from '@mui/material';
import { useBentoTheme } from '@/hooks/brand/useBentoTheme';

type MuiThemeProviderProps = {
  children?: React.ReactNode;
};

function MuiThemeProvider({ children }: MuiThemeProviderProps) {
  const { theme } = useBentoTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default MuiThemeProvider;
